<template src="./home.html"></template>

<script>
import { get_elencoCom } from "@/api/api.home.js";

export default {
  data: () => ({
    elencoNews: [],
    show: [],
  }),

  methods: {
    async init() {
      let resUpdate = await this.$i2kFunctions.checkUpdate(
        this.$load.getUrlUpdate()
      );

      if (resUpdate) this.$toast.update("E' disponibile una nuova versione");
    },

    async CaricaDati() {
      this.elencoNews = [];
      let res = await get_elencoCom();
      this.elencoNews = res.data;
    },
    async CaricaAllegati(item) {
      item.show = !item.show;
    },

    getData(data) {
      let dataa = new Date(data)
      return this.$i2kFunctions.formatDate_IT(dataa);
    },
  },

  mounted() {
    this.init();
    this.CaricaDati();
  },
};
</script>
